module.exports = __webpack_public_path__ + "img/1566680963.47572a31.jpg";